export default "* Gnist\n* Ild\n* Bål";